import { Flex } from 'components/layout';
import { formatCurrency } from 'utils/formatCurrency';

import { LTLRateMetadata } from '../LTLRateCardMetadata';

interface RateMetadataTooltipProps {
  rateMetadata: LTLRateMetadata;
}

export function RateMetadataTooltipContent({
  rateMetadata,
}: RateMetadataTooltipProps) {
  const {
    buyRateTotal = 0,
    sellRateTotal = 0,
    threeGProfitMarkup,
    threeGMarginPercentage,
    threeGNetAccessorials,
  } = rateMetadata;
  const profitMarkup = threeGProfitMarkup ?? 0;
  const marginPercentage = threeGMarginPercentage ?? '0%';
  const netAccessorials = threeGNetAccessorials ?? 0;

  return (
    <div className='p-2'>
      <Flex direction='col' gap='xs' className='text-xs min-w-[240px]'>
        <Flex align='center' justify='between' gap='lg' className='w-full'>
          <span className='text-neutral-700 font-semibold flex-1'>
            Buy total
          </span>
          <span className='text-neutral-700 text-right tabular-nums shrink-0'>
            {formatCurrency(buyRateTotal, 'USD', 2)}
          </span>
        </Flex>
        <Flex align='center' justify='between' gap='lg' className='w-full'>
          <span className='text-neutral-700 font-semibold flex-1'>
            Sell total
          </span>
          <span className='text-neutral-700 text-right tabular-nums shrink-0'>
            {formatCurrency(sellRateTotal, 'USD', 2)}
          </span>
        </Flex>
        <Flex align='center' justify='between' gap='lg' className='w-full'>
          <span className='text-neutral-700 font-semibold flex-1'>
            Profit markup
          </span>
          <span className='text-neutral-700 text-right tabular-nums shrink-0'>
            {formatCurrency(profitMarkup, 'USD', 2)}
          </span>
        </Flex>
        <Flex align='center' justify='between' gap='lg' className='w-full'>
          <span className='text-neutral-700 font-semibold flex-1'>Margin</span>
          <span className='text-neutral-700 text-right tabular-nums shrink-0'>
            {marginPercentage}
          </span>
        </Flex>
        <Flex align='center' justify='between' gap='lg' className='w-full'>
          <span className='text-neutral-700 font-semibold flex-1'>
            Net accessorials
          </span>
          <span className='text-neutral-700 text-right tabular-nums shrink-0'>
            {formatCurrency(netAccessorials, 'USD', 2)}
          </span>
        </Flex>
      </Flex>
    </div>
  );
}
